<template>
  <div class="widget-item" :id="widget.object.wid" :style="style">
    <TimeView class="time-app" :app="widget.object" @saveData="saveAppData" />
  </div>
</template>

<script>
  import TimeView from '@/components/apps/time/TimeView.vue';
  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import { SET_APP_DATA } from '@/store/actions/player';

  export default {
    name: 'TimeWidget',

    components: { TimeView },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          overflow: 'hidden',
        });
      },
    },

    methods: {
      saveAppData(data = null) {
        this.$store.commit(SET_APP_DATA, {
          appId: this.widget.object.wid,
          appData: { appType: this.widget.object.item_type, data },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
